import ProcessCompletedPage from './ProcessCompletedPage'

export default ProcessCompletedPage
